// Third party
import { ListingByIdAndUserQuery, ListingByIdAndUserDocument } from '@gql';

// Utils
import { createApolloClient } from '../apollo-node-client';

export const imperativeServerListingByIdAndUserQuery = async (
  accessToken: string,
  listingId: string
) => {
  const apolloClient = createApolloClient(accessToken);
  const response = await apolloClient.query<ListingByIdAndUserQuery>({
    ...{
      query: ListingByIdAndUserDocument,
      variables: { id: listingId },
    },
  });

  return response;
};
